<div class="main-container">
  <div class="close-icon">
    <button class="close-icon-style" mat-button matDialogClose>
      <span class="material-icons">
        close
      </span></button>
  </div>
  <div class="info-text bold-font" autofocus>{{lblDetails | titlecase}}</div>
  <div class="header-text " translate="lblReportedActivitiesDisclaimerDetails">Activity details typically post
    within 2 hours.</div>
  <div class="close-button"><button class="ok-button bold-font" translate="lblOK" [mat-dialog-close]="true">Ok</button>
  </div>
</div>